"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-int");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* tslint:disable */


exports["default"] = function (_a) {
  var _b = _a.width,
      width = _b === void 0 ? '32px' : _b,
      _c = _a.height,
      height = _c === void 0 ? '32px' : _c,
      _d = _a.color,
      color = _d === void 0 ? '#000' : _d,
      _e = _a.bgColor,
      bgColor = _e === void 0 ? '#FFF' : _e,
      rest = __rest(_a, ["width", "height", "color", "bgColor"]);

  return react_1["default"].createElement("svg", __assign({}, rest, {
    width: width,
    height: height,
    viewBox: "0 0 " + Number.parseInt(width) + " " + Number.parseInt(height)
  }), react_1["default"].createElement("g", {
    stroke: 'none',
    fill: 'none',
    strokeWidth: '1',
    fillRule: 'evenodd'
  }, react_1["default"].createElement("g", {
    transform: 'translate(-360.000000, -2419.000000)',
    fill: '#064650',
    fillRule: 'nonzero'
  }, react_1["default"].createElement("g", {
    transform: 'translate(360.000000, 2416.000000)'
  }, react_1["default"].createElement("g", {
    transform: 'translate(0.000000, 3.000000)'
  }, react_1["default"].createElement("path", {
    d: 'M24.6666667,29.7146667 C20.6226667,29.7146667 17.3333333,26.4253333 17.3333333,22.3813333 L17.3333333,10.4746667 C16.892,10.412 16.4453333,10.3813333 16,10.3813333 C15.5546667,10.3813333 15.108,10.4133333 14.6666667,10.4746667 L14.6666667,22.3813333 C14.6666667,26.4253333 11.3773333,29.7146667 7.33333333,29.7146667 C3.28933333,29.7146667 0,26.4253333 0,22.3813333 C0,20.8333333 0.485333333,19.348 1.40266667,18.0853333 L5.38666667,8.78533333 C5.42,8.70666667 5.468,8.63733333 5.528,8.576 L7.42666667,6.67866667 L9.376,1.48 C9.41466667,1.376 9.47866667,1.284 9.56133333,1.212 C10.2346667,0.625333333 11.1,0.301333333 12,0.301333333 C12.9,0.301333333 13.7653333,0.624 14.4386667,1.212 C14.584,1.33866667 14.6666667,1.52266667 14.6666667,1.71466667 L14.6666667,7.048 C14.6666667,7.416 14.368,7.71466667 14,7.71466667 C13.632,7.71466667 13.3333333,7.416 13.3333333,7.048 L13.3333333,2.04133333 C12.944,1.77733333 12.476,1.63466667 12,1.63466667 C11.4786667,1.63466667 10.9706667,1.80533333 10.5613333,2.11733333 L8.624,7.28133333 C8.59066667,7.372 8.53866667,7.452 8.472,7.51866667 L6.56266667,9.428 L3.75066667,15.9866667 C4.84133333,15.3693333 6.06,15.0466667 7.33333333,15.0466667 C9.732,15.0466667 11.9733333,16.2453333 13.3333333,18.1813333 L13.3333333,10.768 C12.1213333,11.1533333 11.3333333,11.7773333 11.3333333,12.38 C11.3333333,12.748 11.0346667,13.0466667 10.6666667,13.0466667 C10.2986667,13.0466667 10,12.748 10,12.38 C10,10.48 12.58,9.04666667 16,9.04666667 C19.42,9.04666667 22,10.48 22,12.38 C22,12.748 21.7013333,13.0466667 21.3333333,13.0466667 C20.9653333,13.0466667 20.6666667,12.748 20.6666667,12.38 C20.6666667,11.7773333 19.8786667,11.1533333 18.6666667,10.768 L18.6666667,18.1813333 C20.0266667,16.2453333 22.268,15.0466667 24.6666667,15.0466667 C25.9386667,15.0466667 27.1586667,15.368 28.2493333,15.9866667 L25.4386667,9.428 L23.5293333,7.51866667 C23.4626667,7.452 23.4106667,7.37066667 23.3773333,7.284 L21.44,2.20133333 C21.0293333,1.88933333 20.5213333,1.71866667 20,1.71866667 C19.524,1.71866667 19.056,1.86266667 18.6666667,2.12533333 L18.6666667,7.048 C18.6666667,7.416 18.368,7.71466667 18,7.71466667 C17.632,7.71466667 17.3333333,7.416 17.3333333,7.048 L17.3333333,1.79866667 C17.3333333,1.60666667 17.416,1.42266667 17.5613333,1.296 C18.2333333,0.709333333 19.1,0.385333333 20,0.385333333 C20.9,0.385333333 21.7653333,0.708 22.4386667,1.296 C22.52,1.36666667 22.584,1.45866667 22.624,1.56 L24.5733333,6.676 L26.472,8.57466667 C26.532,8.63466667 26.58,8.70533333 26.6133333,8.784 L30.6,18.0866667 C31.516,19.3493333 32,20.832 32,22.3786667 C32,26.4253333 28.7106667,29.7146667 24.6666667,29.7146667 Z M24.6666667,16.3813333 C21.3586667,16.3813333 18.6666667,19.0733333 18.6666667,22.3813333 C18.6666667,25.6893333 21.3586667,28.3813333 24.6666667,28.3813333 C27.9746667,28.3813333 30.6666667,25.6893333 30.6666667,22.3813333 C30.6666667,19.0733333 27.9746667,16.3813333 24.6666667,16.3813333 Z M7.33333333,16.3813333 C4.02533333,16.3813333 1.33333333,19.0733333 1.33333333,22.3813333 C1.33333333,25.6893333 4.02533333,28.3813333 7.33333333,28.3813333 C10.6413333,28.3813333 13.3333333,25.6893333 13.3333333,22.3813333 C13.3333333,19.0733333 10.6413333,16.3813333 7.33333333,16.3813333 Z'
  }))))));
};
/* tslint:enable */